import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import type { Site } from "@/types";

type Params = {
  project_id: string;
};

export function useSites(params: Params) {
  const query = buildParams(params);

  return useQuery({
    queryKey: ["sites", params],
    queryFn: () => apiFetch<Site[]>(`/v1/home/sites${query}`),
    enabled: !!params.project_id,
  });
}
